import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgHandshake = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m27.814 11.803-2.791-5.585a1.75 1.75 0 0 0-2.348-.782l-2.72 1.36-5.73-1.516a.89.89 0 0 0-.45 0l-5.73 1.515-2.72-1.359a1.75 1.75 0 0 0-2.348.782l-2.79 5.584a1.75 1.75 0 0 0 .781 2.348l2.953 1.477 6.07 4.335c.089.064.19.11.296.137l7 1.75a.875.875 0 0 0 .831-.23l6.023-6.024 2.89-1.445a1.75 1.75 0 0 0 .782-2.347h.001Zm-6.003 3.65-3.764-3.015a.875.875 0 0 0-1.168.067c-1.948 1.962-4.12 1.714-5.504.839l4.73-4.594h3.479l2.976 5.951-.75.752ZM4.542 7l2.24 1.118L3.984 13.7 1.75 12.585 4.542 7ZM17.23 20.03l-6.356-1.588-5.381-3.844 3.062-6.125L14 7.031l1.072.283-4.922 4.777-.009.01a1.75 1.75 0 0 0 .298 2.714c2.249 1.436 4.962 1.203 7.1-.547l3.024 2.43-3.333 3.332Zm6.781-6.33L21.22 8.122 23.458 7l2.792 5.585-2.239 1.115Zm-9.597 10.136a.876.876 0 0 1-1.061.637l-4.558-1.14a.863.863 0 0 1-.296-.137l-2.882-2.058a.875.875 0 0 1 1.017-1.422l2.746 1.962 4.401 1.098a.875.875 0 0 1 .637 1.061h-.004Z" />
  </svg>
);
export default SvgHandshake;
